<template>
  <div :class="$style[classes]">
      <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :layout="layout" :pageSizes="pageSizes"
      :page-size="pageSize" ref="table" v-loading="loading" isAddPageToRouter :isOutside="isOutside">
          <wt-table :list="tableData" :labels="tableLabels">
            <template slot="before">
              <el-table-column label="积分商品主图" min-width="120">
                <template slot-scope="scope">
                  <pt-img :class="$style['integral-goods-pictrue']" :src="scope.row.goodsDTO.goodsData.mainPicture"/>
                </template>
              </el-table-column>
              <el-table-column label="积分商品名称" min-width="150">
                <template slot-scope="scope">
                  {{scope.row.goodsDTO.goodsData.name}}
                </template>
              </el-table-column>
              <el-table-column label="规格">
                <template slot-scope="scope">
                  <template v-if="scope.row.goodsDTO&&scope.row.goodsDTO.goodsData&&scope.row.goodsDTO&&scope.row.goodsDTO.goodsData.specifications">
                  <div v-for="(item,index) in scope.row.goodsDTO.goodsData.specifications" :key="index">
                    {{item.name}}
                  </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="所需积分">
                <template slot-scope="scope">
                  <div v-for="(item,index) in scope.row.goodsDTO.goodsData.specifications" :key="index">
                    {{item.price}}
                  </div>
                </template>
              </el-table-column>
            </template>
            <template>
              <slot/>
            </template>
          </wt-table>
      </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-integral-goods-table'
export default {
  name: 'pt-integral-goods-table',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean
    },
    pageSize: {
      type: Number,
      default: 20
    },
    isOutside: {
      type: Boolean
    },
    tableData: {
      type: Array
    },
    tableLabels: {
      type: Array
    },
    pageSizes: {
      type: Array,
      default: function () {
        return [10, 20, 30, 50, 200]
      }
    },
    layout: {
      type: String,
      default: 'total,sizes, prev, pager, next,jumper'
    }
  },
  methods: {
    getTableData (page, next) {
      this.$emit('getTableData', page, next)
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    showReTry () {
      this.$refs.table.showReTry()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.integral-goods-pictrue{
  width: 100px;
}
.pt-integral-goods-table{
  :global{
    .el-button{
      margin-left: 0px;
      margin-right: 10px
    }
  }
}
</style>
